<script lang="ts">
  import {numberOfSecurities} from 'Utility/investorFlow/v2/amountSelection';
  import {incentivePlans} from 'Store/deals/incentivePlan';
  import Button from 'Catalyst/components/Button/Button.svelte';
  import CatalystStyleOverwrite from 'Components/InvestorFlow/CatalystStyleOverwrite.svelte';
  import {centsToString} from 'Utility/formatters/currency';
  import {integerMask} from 'Utility/formatters/mask';

  export let amount: number; // In cents
  export let pricePerSecurity: number; // In cents
  export let exchangePrice: boolean;
  export let hideUnitConverter: boolean;
  export let currencySymbol: string;
  export let numSecurities: number;

  $: finalPrice =
    $incentivePlans?.final_price?.amount_cents || pricePerSecurity;
  $: fullPrice = $incentivePlans?.full_price?.amount_cents;
  $: originalNumberOfSecurities = numberOfSecurities(amount, fullPrice);
  $: originalInvestmentAmount =
    numberOfSecurities(amount, finalPrice) * fullPrice;

  $: hasIncentive = !!$incentivePlans?.effective_tier || finalPrice < fullPrice;

  $: amountMatches = numSecurities === originalNumberOfSecurities;
  $: mappings = {
    '--button-compound-variants-style-filled-and-semantic-brand-base-bg-color':
      '--dm-bg-secondary-color',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-hover-base-bg-color':
      '--dm-bg-secondary-color',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-focus-base-bg-color':
      '--dm-bg-secondary-color',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-active-base-bg-color':
      '--dm-bg-secondary-color',
    '--button-compound-variants-style-filled-and-semantic-brand-label-color':
      '--dm-text-primary-color',
    '--button-slots-base-border-radius': '9999px',
  };

  $: selectedMappings = {
    '--button-compound-variants-style-filled-and-semantic-brand-base-bg-color':
      '--palettes-brand-color-50',
    '--button-variants-style-filled-surface-disabled':
      '--palettes-brand-color-50',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-hover-base-bg-color':
      '--palettes-brand-color-50',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-focus-base-bg-color':
      '--palettes-brand-color-50',
    '--button-compound-variants-style-filled-and-semantic-brand-and-state-active-base-bg-color':
      '--palettes-brand-color-50',
    '--button-compound-variants-style-filled-and-semantic-brand-label-color':
      '--palettes-brand-color-700',
    '--button-slots-base-border-radius': '9999px',
  };
</script>

{#key numSecurities}
  <CatalystStyleOverwrite
    mappings={amountMatches ? selectedMappings : mappings}
  >
    <Button class={'w-full'} on:click data-testid="preset-amount-{amount}">
      <div
        class="text-center"
        class:light-gray={!exchangePrice}
        class:selected-text={amountMatches}
      >
        {#if !exchangePrice && hasIncentive}
          <s data-testid="original-investment-amount-{amount}"
            >{currencySymbol}{centsToString(originalInvestmentAmount, {
              removeZeroCents: true,
            })}</s
          >
        {/if}
        <span data-testid="investment-amount-{amount}"
          >{currencySymbol}{centsToString(amount, {
            removeZeroCents: true,
          })}</span
        >
      </div>
      {#if !hideUnitConverter}
        <div class:light-gray={!amountMatches}>&#9679</div>
        <div
          class:light-gray={exchangePrice && !amountMatches}
          class:selected-text={amountMatches}
        >
          {#if exchangePrice && hasIncentive}
            <s data-testid="original-number-of-securities-{amount}"
              >{integerMask(originalNumberOfSecurities)}</s
            >
          {/if}
          <span data-testid="number-of-securities-{amount}"
            >{integerMask(numberOfSecurities(amount, finalPrice))}</span
          >
        </div>
      {/if}
    </Button>
  </CatalystStyleOverwrite>
{/key}

<style>
  .light-gray {
    color: var(--dm-text-secondary-color, var(--palettes-neutral-575, #667085));
  }
</style>
